module.exports = __webpack_public_path__ + "static/media/banner_3.0f5dbb02.jpg";